
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

enum cheatEnum {
  "faceDetection" = "仪容仪表检测"
}

const cheatKeys = ["faceDetection", "dressingDetection", "smokeDetection"];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];

//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

@Component({
  components: { SvgImgV3 }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  showVideo = false;

  isIphone = false; // iphone播放按钮和版本也有关，目前试着13一直显示，14以上不显示

  getFontCode(index: number) {
    return ["&#xe71d;", "&#xe71c;", "&#xe71f;"][index];
  }

  //
  mounted() {
    document.addEventListener("fullscreenchange", this.checkFullscreen);
  }
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.checkFullscreen);
  }
  //全屏视频修改填充样式
  isVideoFullscreen = false;
  scrollPosition = 0;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }
  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
  }

  faceResText(i: number) {
    return enumFinger[i];
  }

  faceText(i: number) {
    return ["未检测", "通过", "未通过"][i];
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }
}
